module.exports = __webpack_public_path__ + "static/media/Icn-exe.1ac92923.svg";